import React, { useState, useRef, useEffect } from "react";
import PinInput from 'react-pin-input';
import { Redirect } from "react-router-dom";


export default function TwoFactorAuth(props) {
    const [code2FA, setCode2FA] = useState("")
    const [triesLeft, setTriesLeft] = useState(3)
    const [sucess, setSucess] = useState(false)
    const [time, setTime] = useState(300) // 2FA kod vrijedi 5 min

    const formatSeconds = s => new Date(s * 1000).toISOString().substr(15, 4);

    function login2FA(e) {
        e.preventDefault();
        props.showLoadingFn(true);
        let ttId = casino.utils.getCookie("_tdid");
        if (ttId == null) {
            ttId = casino.utils.uuidv4();
            casino.utils.setCookie("_tdid", ttId, 180);
        }
        casino.repos.sessionRepo.create2FA(code2FA, props.refID2FA, ttId).then(
            function (login) {
                props.showLoadingFn(false);
                if (login.sesija.sesijaId) {
                    props.updateUserFn(login.sesija.igrac, login.sesija.sesijaId);
                    setTimeout(props.getNotifikacijeFn, 2000);
                    if (typeof ga !== 'undefined') // google analytics
                        ga('send', { hitType: 'event', eventCategory: 'Actions', eventAction: 'UspjesnaPrijava' });


                    //Google tag manager
                    casino.utils.createGoogleTagManagerEvent({
                        'event': 'userID',
                        'user_id': login.sesija.igrac.token,
                        'accountID': login.sesija.igrac && login.sesija.igrac.publicID || ""
                    });
                    // postavim pokusaje na -1 dok je sucess da mogu nacrtati "verifikacija je uspjesna" pa sa sucess stateom redirectam 
                    setTriesLeft(-1)
                }
                else {
                    setTriesLeft(triesLeft - 1)
                }
            });
    }

    useEffect(() => {
        //postavim sucess tek nakon 2 sekunde da se pokaze "sucess screen" na 2 sekunde
        if (triesLeft == -1) {
            setTimeout(() => {
                setSucess(true)
            }, 1200);
        }
    }, [triesLeft])

    useEffect(() => {
        let timer = setInterval(() => {
            setTime((time) => {
                if (time === 0) {
                    clearInterval(timer);
                    setTriesLeft(0)
                    return 0;
                } else return time - 1;
            });
        }, 1000);
    }, []);

    return (
        <>

            {sucess && <Redirect to={props.route.location.state?.from ? props.route.location.state?.from : props.getHomePathFn(props.route.location)} />}
            <div className="twoFA-container">
                <h1>Verifikacijski kod</h1>
                <div className="text">Unesi verifikacijski kod koji smo ti poslali na tvoju email adresu.</div>
                <PinInput
                    disabled={!triesLeft}
                    length={6}
                    initialValue=""
                    onChange={(value, index) => { setCode2FA(value) }}
                    type="numeric"
                    onComplete={(value, index) => { setCode2FA(value) }}
                    inputMode="number"
                    inputStyle={{ background: '#F8F8F8', borderColor: "#EDEDED", width: '40px', margin: "0px 7px" }}
                    inputFocusStyle={{ background: '#FFF', borderColor: "#EDEDED" }}
                    autoSelect={false}
                />
                <div className="timer">Kod vrijedi još  <span style={{color: "#00B6F7"}}>{formatSeconds(time)}</span>
                </div>
                <div className="container">
                    {triesLeft != 3 &&
                        <div className={`tries-left-container ${triesLeft > 0 ? "" : triesLeft == 0 ? "red" : "green"}`}>
                            {triesLeft > 0 && <>
                                <img src="content/images/assets/ic_yellow_checkmark_player_status.png" />
                                <div className="tries-left">Kod nije ispravan! Imaš još {triesLeft} pokušaj{triesLeft == 1 ? "" : "a"}! </div>
                            </>}
                            {triesLeft == 0 &&
                                <>
                                    <img src="content/images/assets/cancel.png" />
                                    <div className="tries-left"> Verifikacija nije uspjela. </div>
                                    <button className="btn-ponovo" onClick={() => window.location.reload()}>Ponovo
                                        <img src="content/images/assets/ic_arrow_more_white_R.png" />
                                    </button>
                                </>
                            }
                            {triesLeft == -1 && <>
                                <img src="content/images/assets/checkmark.png" />
                                <div className="tries-left">Verifikacija je uspjela.</div>
                            </>}
                        </div>}
                </div>

                {triesLeft != -1 &&
                    <>
                        <div className="email">Nisi primio email s kodom ili želiš promijeniti svoj email? Javi nam se na <a className="link red" href="mailto:ssport@supersport.hr">ssport@supersport.hr</a></div>
                        <button disabled={code2FA.length < 6 || triesLeft == 0} className="btn fill large login" onClick={login2FA}>Nastavi</button>
                    </>
                }
            </div>
        </>
    )
}